// import { logger } from "redux-logger";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import OrganizationsPageSlice from "./SettingModule/OrganizationsPage/OrganizationsPageSlice";
import QCDetailPageSlice from "./JobModule/QCDetailPage/QCDetailPageSlice";
import InProgressAudiosSlice from "./JobModule/InProgressPage/InprogressSlice";
import ArchivedAudiosSlice from "./JobModule/ArchivedPage/ArchivedSlice";
import NewCompletedAudiosSlice from "./JobModule/CompletedPage/NewCompletedSlice";
import TranscribeSlice from "./Transcribe/TranscribeSlice";
import UsersPageSlice from "./SettingModule/UsersPage/UsersSlice";
import OrganizationDetailPageSlice from "./SettingModule/OrganizationDetailPage/OrganizationDetailSlice";

export const rootReducer = combineReducers({ UsersPageState: UsersPageSlice, OrganizationsPageState: OrganizationsPageSlice, qCDetailPageState: QCDetailPageSlice, InProgressAudiosState: InProgressAudiosSlice, ArchivedAudiosState: ArchivedAudiosSlice, NewCompletedAudiosState: NewCompletedAudiosSlice, TranscribeState: TranscribeSlice, OrganizationDetailPageState: OrganizationDetailPageSlice });
export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({ reducer: rootReducer });
export type AppDispatch = typeof store.dispatch;
export default store;
